import React, { Component, Fragment } from 'react';

import {
  ConfirmNavigation,
  renderConfirmNavigationModal
} from 'components/modal';
import isEmpty from 'lodash/isEmpty';
import isEqual from 'lodash/isEqual';
import { inject } from 'mobx-react';
import PropTypes from 'prop-types';

const defaultConfigs = {
  bodyLabel: 'prevent_leave.body',
  cancelLabel: 'prevent_leave.continue',
  onConfirmLabel: 'prevent_leave.leave',
  onConfirmSecondary: {
    label: 'prevent_leave.leave'
  },
  title: 'prevent_leave.header'
};

@inject((stores) => ({
  hasInvalidToken: stores.UserStore.hasInvalidToken
}))
export default class ContentPreventLeave extends Component {
  static propTypes = {
    children: PropTypes.node,
    snapshot: PropTypes.object,
    current: PropTypes.object,
    onConfirm: PropTypes.func,
    hasInvalidToken: PropTypes.bool,
    hasUnsavedData: PropTypes.bool,
    isForceDirty: PropTypes.bool
  };

  constructor(props) {
    super(props);

    this.state = {
      isDirty: false
    };
  }

  static getDerivedStateFromProps(props) {
    const { snapshot, current } = props;
    const isDirty = ContentPreventLeave.isDirty(snapshot, current);

    return { isDirty };
  }

  checkDirty = () => {
    const { snapshot, current } = this.props;

    return ContentPreventLeave.isDirty(snapshot, current);
  };

  static isDirty = (snapshot, current) => {
    return !(isEmpty(snapshot) || isEqual(snapshot, current));
  };

  static renderModal = ({ onConfirm, onCancel, onConfirmSecondary }) =>
    renderConfirmNavigationModal({
      ...defaultConfigs,
      onConfirm: { action: onConfirm, label: defaultConfigs.onConfirmLabel },
      onConfirmSecondary: {
        action: onConfirmSecondary,
        label: defaultConfigs.onConfirmSecondary.label
      },
      onCancel
    });

  render() {
    const {
      onConfirm,
      hasInvalidToken,
      hasUnsavedData = false,
      isForceDirty
    } = this.props;
    const { isDirty } = this.state;
    const shouldPreventLeave =
      (isDirty && !hasInvalidToken) || hasUnsavedData || isForceDirty;

    if (!shouldPreventLeave) {
      return null;
    }

    return (
      <Fragment>
        <ConfirmNavigation
          {...defaultConfigs}
          onConfirm={{
            action: onConfirm,
            label: defaultConfigs.onConfirmLabel
          }}
          shouldConfirmNavigation={shouldPreventLeave}
        />

        {this.state.preventLeave &&
          renderConfirmNavigationModal(defaultConfigs)}
      </Fragment>
    );
  }
}
